import { client } from '../apiClient';
import { AppNotification } from '../../types/notifications/Notification';

const NOTIFICATIONS_ENDPOINT = '/notifications';

export const getNotifications = async (): Promise<AppNotification[]> => {
  const { data } = await client(true, true).get<AppNotification[]>(NOTIFICATIONS_ENDPOINT);
  return data;
};

export const markNotificationsSeen = async (types: string[]): Promise<void> => {
  await client(true, true).post(`${NOTIFICATIONS_ENDPOINT}/mark-seen`, { types });
};
